import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State, OrgIntegrationState, FieldMappingState, WistiaProjectsState, SalesforceOrgState } from './types';

const orgIntegrationDefaultState = (): OrgIntegrationState => ({
  isInitializeIntegrationLoading: true,
  trayLiveSolutions: {},
  isTrayLiveSolutionsLoading: false,
  trayAuthentications: [],
  inHouseAuthentications: [],
  isAuthenticationsLoading: false,
  traySolutionInstances: [],
  isSolutionInstancesLoading: false,
  currentSolutionInstance: null,
  currentSolutionIframeSrc: null,
  currentAuthentication: null,
  currentAuthenticationIframeSrc: null,
  isTrayLoading: false,
  trayError: null,
  isValidEloquaAuthConnected: true,
  isEloquaAuthHealthApiLoading: false,
  isIntegrationSettingsLoading: false,
  integrationSettings: [],
  isNativeIntegration: false,
  slackCurrentUser: null
});

const fieldMappingDefaultState = (): FieldMappingState => ({
  currentCrmType: '',
  crmObjectTypes: [],
  isCrmObjectTypesLoading: false,
  sourceFields: [],
  isSourceFieldLoading: false,
  targetFields: {},
  fieldMappings: {},
  prevFieldMappings: {},
  fieldMappingRowError: {},
  isSaveFieldMappingLoading: {},
  isPrePopulateRequiredMappingsInProgress: false,
  customFieldMappings: {}
});

const wistiaProjectsDefaultState = (): WistiaProjectsState => ({
  wistiaProjects: [],
  isWistiaProjectsLoading: false
});

const salesforceDefaultState = (): SalesforceOrgState => ({
  isSalesforceValidateCampaignIdOrgLoading: false,
  isSalesforceCampaignStatusOrgLoading: false,
  isSalesforceConnectCampaignOrgLoading: false
});

export const getDefaultState = (): State => ({
  ...orgIntegrationDefaultState(),
  ...fieldMappingDefaultState(),
  ...wistiaProjectsDefaultState(),
  ...salesforceDefaultState()
});

const state: State = getDefaultState();

export default {
  actions,
  mutations,
  state,
  getters,
  namespaced: true
};
